import React, { Component } from "react";
import styled from 'styled-components';
import { Container, Icon, Menu, Transition } from 'semantic-ui-react';
import { SemanticICONS } from 'semantic-ui-react/dist/commonjs/generic';
import { SidebarConsumerRenderProps, withSidebarContext } from 'components/sidebar/SidebarContext';

const StyledMenuItem = styled(Menu.Item)`
  .ui.menu &.item {
    color: white;
    text-decoration: none;
    transition: width 0.35s;
  }

  .ui.labeled.icon.menu &.item {
    min-width: 0;
    font-size: 0.85rem;
  }
`;

const StyledTransition = styled(Container)`
  height: ${props => props.compact ? "0" : "auto"};
`;

interface Props extends SidebarConsumerRenderProps {
  icon: SemanticICONS,
  iconComponent: Component,
  title: string,
  enabled: boolean,
  active: boolean,
  onClick: () => void
}

class SidebarItem extends Component<Props> {

  public static defaultProps = {
    enabled: true
  };

  render(): React.ReactNode {

    const { compactView, icon, iconComponent, title, enabled, active, onClick } = this.props;

    if (!enabled) {
      return <></>
    }

    return (
        <StyledMenuItem link onClick={onClick} active={active}>
          {
            iconComponent
                ? iconComponent
                : <Icon name={icon} inverted/>
          }
          <Transition visible={!compactView} animation='slide right' duration={350}>
            <StyledTransition as="div" compact={compactView}>
              {title}
            </StyledTransition>
          </Transition>
        </StyledMenuItem>
    );
  }
}

export default withSidebarContext(SidebarItem);
